import { Game } from "../../../Game";
import { Player } from "./Player";
import { Gameplay, eState as eGameplayState } from "../../Gameplay";



export class Controls {
    get player(): Player { return this._player; }
    private _player: Player;

    /**
     * (RO) Aktualni smer pusobeni sily (-1 = vlevo, 0 = nikam, 1 = vpravo)
     */
    get forceDir(): number { return this._forceDir; }
    private _forceDir: number;

    private _touchId: number;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor(player: Player) {
        this._player = player;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    reset(): void {
        this._forceDir = 0;
        this._touchId = undefined;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    activate(): void {
        if (Game.app.keyboard) {
            Game.app.keyboard.on(pc.EVENT_KEYDOWN, this.handleKeyDown, this);
            Game.app.keyboard.on(pc.EVENT_KEYUP, this.handleKeyUp, this);
        }

        if (Game.app.touch) {
            Game.app.touch.on(pc.EVENT_TOUCHSTART, this.handleTouchStart, this);
            Game.app.touch.on(pc.EVENT_TOUCHEND, this.handleTouchEnd, this);
            Game.app.touch.on(pc.EVENT_TOUCHCANCEL, this.handleTouchEnd, this);
        }
        else if (Game.app.mouse) {
            Game.app.mouse.on(pc.EVENT_MOUSEDOWN, this.handleMouseDown, this);
            Game.app.mouse.on(pc.EVENT_MOUSEUP, this.handleMouseUp, this);
        }
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    private handleKeyDown(event: pc.KeyboardEvent): void {
        if (Game.paused || Gameplay.instance.state != eGameplayState.started)
            return;

        if (event.key == pc.KEY_LEFT) {
            this._forceDir = -1;
        }
        else if (event.key == pc.KEY_RIGHT) {
            this._forceDir = 1;
        }
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    private handleKeyUp(event: pc.KeyboardEvent): void {
        if ((event.key == pc.KEY_RIGHT && this._forceDir == 1) || (event.key == pc.KEY_LEFT && this._forceDir == -1))
            this._forceDir = 0;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    private handleMouseDown(event: pc.MouseEvent): void {
        if (Game.paused || Gameplay.instance.state != eGameplayState.started)
            return;

        this._forceDir = event.x < Game.scale.outputWidth / 2 ? -1 : 1;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    private handleMouseUp(): void {
        this._forceDir = 0;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    private handleTouchStart(event: pc.TouchEvent): void {
        if (Game.paused || Gameplay.instance.state != eGameplayState.started)
            return;

        let touch = event.changedTouches[event.changedTouches.length - 1];

        if (touch.y < Game.scale.outputHeight / 6)
            return;

        this._touchId = touch.id;
        this._forceDir = touch.x < Game.scale.outputWidth / 2 ? -1 : 1;

        event.event.preventDefault();
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    private handleTouchEnd(event: pc.TouchEvent): void {
        if (this._touchId != undefined) {
            let i = event.changedTouches.length;

            while (i-- != 0) {
                if (this._touchId == event.changedTouches[i].id) {
                    this._touchId = undefined;
                    this._forceDir = 0;
                    break;
                }
            }
        }

        event.event.preventDefault();
    }
}